import { useEffect } from 'react';

function JI_title() {
  useEffect(() => {
    document.title = 'JINet Innovations';
  }, []);
}

export default JI_title;

